export default "__VITE_ASSET__2jBjLvIW__"